<template>
  <b-container fluid>
    <!-- Top Section !-->
    <b-row>
      <b-col lg="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">Users</h4>
          </template>
          <template v-slot:headerAction>
            <b-breadcrumb class="mt-3" :items="breadcrumIcon" style="background:none" />
          </template>
          <template v-slot:body>
            <b-row>
              <b-col cols="12" md="2">
                <input type="text" placeholder="Search user..." class="form-control" v-model="usersData.params.search">
              </b-col>
              <b-col cols="12" md="3">
                <v-select
                  v-model="usersData.params.companyId"
                  label="company"
                  :options="companies"
                  :reduce="company => company.id"
                  placeholder="Select Company"
                ></v-select>
              </b-col>
              <b-col cols="12" md="2">
                <v-select
                  v-model="usersData.params.active"
                  label="text"
                  :options="statuses"
                  :reduce="status => status.value"
                  placeholder="Select Status"
                ></v-select>
              </b-col>
              <b-col cols="12" md="2">
                <b-button variant="primary" class="mb-3 mr-1" @click="fetchUsers(1)"
                  ><i class="fa fa-search"></i></b-button
                >
              </b-col>
              <b-col cols="12" md="3" class="text-right"
                v-if="findMenuPermission(1, 'add', $route.query.menuId)">
                <router-link :to="{ name: 'setting.addNewUser', query: { menuObject: $route.query.menuObject } }"
                  ><b-button variant="success" class="mb-3 mr-1"
                    ><i class="fa fa-plus"></i>Add User</b-button
                  ></router-link
                >
              </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <!-- End Top Section !-->
    <!-- Content Section !-->
    <b-row>
     
      <b-col lg="12">
        <iq-card>
          <template v-slot:headerAction>
            <b-col>
              <div class="justify-content-end text-right">
                <strong>Display : &nbsp;</strong>
                <div class="btn-group">
                  <button
                    type="button"
                    @click="view_style = 'list'"
                    class="btn btn-outline-primary"
                    :class="{ active: view_style === 'list' }"
                  ><span class="fa fa-list"></span> List
                  </button>
                  <button
                    type="button"
                    @click="view_style = 'grid'"
                    class="btn btn-outline-primary"
                    :class="{ active: view_style === 'grid' }"
                  ><span class="fa fa-th-large"></span> Grid
                  </button>
                </div>
              </div>
            </b-col>
          </template>
          <template v-slot:body>
            <div v-if="usersData._loading" class="text-center my-5">
              <b-spinner type="grow" label="Spinning"></b-spinner>
            </div>
            <template v-else>
              <template v-if="view_style === 'list'">
                <div class='d-flex overflow-auto'>
                  <table class="table table-striped">
                    <thead>
                      <tr>
                        <th class="text-center" style="max-width:100px">PHOTO</th>
                        <th class="text-center">NAME</th>
                        <th class="text-center">ROLES</th>
                        <th class="text-center">COMPANY</th>
                        <th class="text-center">ACTION</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(usr, i) in usersData.data" :key="i">
                        <td class="text-center">
                          <router-link :to="{ name: 'setting.viewUser', params: { id: usr.id }, query: { menuObject: $route.query.menuObject } }">
                            <b-img
                              :rounded="'circle'"
                              :src="
                                usr.userDetail.photo
                                  | checkPhoto(
                                    require('@src/assets/images/user/01.jpg')
                                  )
                              "
                              :alt="usr.userDetail.name"
                              style="width:100px; height:100px"
                            />
                          </router-link>
                        </td>
                        <td class="text-center">
                          <div class="d-flex flex-column">
                            <router-link :to="{ name: 'setting.viewUser', params: { id: usr.id }, query: { menuObject: $route.query.menuObject } }">
                              <h6> {{ usr.userDetail.name }} </h6>
                            </router-link>
                            <strong class="mb-0">{{ usr.username }}</strong>
                          </div>
                        </td>
                        <td class="text-center">
                          <p class="mb-0">{{ usr.role.roles }}</p>
                        </td>
                        <td class="text-center">
                          <p class="mb-2">{{ usr.company.company }}</p>
                          <router-link :to="{ name: 'setting.viewUser', params: { id: usr.id }, query: { menuObject: $route.query.menuObject } }">{{
                            usr.company.location
                          }}</router-link>
                        </td>
                        <td v-if="findMenuPermission(1, 'update', $route.query.menuId)" class="text-center">
                          <router-link :to="{ name: 'setting.EditUser', params: { id: usr.id }, query: { menuObject: $route.query.menuObject } }">
                            <b-button variant="success" size="sm" class="mr-2">
                              <i class="fa fa-edit"></i> Edit
                            </b-button>
                          </router-link>
                          <b-button
                            variant="danger"
                            size="sm"
                            v-if="userRole === 'Super Admin'"
                            @click="doRemoveUser(usr.id)"
                            ><i class="fa fa-trash"></i> Remove</b-button
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </template>
              <template v-if="view_style === 'grid'">
                <b-row v-if="usersData.data && usersData.data.length > 0">
                  <b-col v-for="(usr, i) in usersData.data" :key="i" sm="12" md="3">
                    <b-card>
                      <b-card-text>
                        <div class="text-center">
                          <router-link :to="{ name: 'setting.viewUser', params: { id: usr.id }, query: { menuObject: $route.query.menuObject } }">
                            <b-img
                              :rounded="'circle'"
                              :src="
                                usr.userDetail.photo
                                  | checkPhoto(
                                    require('@src/assets/images/user/01.jpg')
                                  )
                              "
                              :alt="usr.userDetail.name"
                              style="width:100px; height:100px"
                            />
                          </router-link>
                        </div>
                        <div class="text-center mt-3">
                          <router-link :to="{ name: 'setting.viewUser', params: { id: usr.id }, query: { menuObject: $route.query.menuObject } }"
                            ><h4> {{ usr.userDetail.name }} </h4></router-link
                          >
                          <strong class="mb-0">{{ usr.username }}</strong>
                          <p class="mb-0">{{ usr.role.roles }}</p>
                          <router-link :to="{ name: 'setting.viewUser', params: { id: usr.id }, query: { menuObject: $route.query.menuObject } }">{{
                            usr.company.location
                          }}</router-link>
                        </div>
                        <div class="text-center mt-2">
                          <p class="mb-0">{{ usr.company.company }}</p>
                          <p class="mb-0">
                            <b-badge :variant="usr.active ? 'warning' : 'danger'" class="ml-2" >
                              {{ usr.active ? 'Active' : 'Not Active' }}
                            </b-badge
                            >
                          </p>
                        </div>
                      </b-card-text>
                      <b-card-footer class="text-center"
                        v-if="findMenuPermission(1, 'update', $route.query.menuId)">
                        <router-link :to="{ name: 'setting.EditUser', params: { id: usr.id }, query: { menuObject: $route.query.menuObject } }">
                          <b-button variant="success" size="sm" class="mr-2"
                            ><i class="fa fa-edit"></i
                          > Edit</b-button>
                        </router-link>

                        <b-button
                          variant="danger"
                          size="sm"
                          v-if="userRole === 'Super Admin'"
                          @click="doRemoveUser(usr.id)"
                          ><i class="fa fa-trash"></i> Remove</b-button
                        >
                      </b-card-footer>
                    </b-card>
                  </b-col>
                </b-row>
              </template>
              <div class="mt-4" v-if="usersData.data && usersData.data.length > 0">
                <b-pagination
                  v-model="usersData.meta.currentPage"
                  :total-rows="usersData.meta.total"
                  @change="fetchUsers"
                  :per-page="usersData.meta.perPage"
                  first-number
                  align="center"
                ></b-pagination>
              </div>
              <p v-else class="mb-0 text-muted text-center">No users data found.</p>
            </template>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <!-- End Content Section !-->
  </b-container>
</template>
<script>
import { usersActions, companiesActions } from '@src/Utils/helper'
import _ from 'lodash'

export default {
  name: 'Users',
  data () {
    return {
      userRole: JSON.parse(localStorage.getItem('profile'))?.role?.roles,
      // Breadcrumb
      view_style:'list',
      breadcrumIcon: [
        {
          html: '<i class="ri-home-4-line mr-1 float-left"></i>Dashboard',
          href: '/ops/home',
          active: false
        },
        {
          html: 'Users',
          href: '#',
          active: true
        },
      ],
      params: {
        page: 1,
        companyId: '',
        active: true,
        search: ''
      },
      companies: [],
      statuses: [
        { value: '', text: 'All' },
        { value: true, text: 'Active' },
        { value: false, text: 'Non Active' },
      ],
      users: [],
      usersData: {
        data: [],
        _loading: true,
        detail: null,
        params: {
          page: 1,
          companyId: '',
          active: true,
          search: '',
          perPage: 24
        },
        meta: {
          perPage: 0,
          currentPage: 0,
          total: 0,
          totalPage: 0
        }
      },
      loading: true,
    }
  },
  created () {
    this.fetchUsers = _.debounce(this.fetchUsers, 500)
  },
  mounted() {
    this.fetchUsers()
    this.fetchCompanies()
  },
  methods: {
    ...usersActions,
    ...companiesActions,
    async fetchUsers(page) {
      this.usersData.params.page = page || 1
      this.usersData._loading = true
      this.usersData.data = []
      let params = this.$options.filters.cleanObject(this.usersData.params)
      let res = await this.getUsers(params)

      if (res.data.status == 'success' || res.data.status == true) {
        if (res.data.data && res.data.data.length > 0) {
          this.usersData.data = res.data.data
          this.usersData.meta.perPage = res.data.perPage
          this.usersData.meta.currentPage = res.data.currentPage
          this.usersData.meta.total = res.data.total
          this.usersData.meta.totalPage = res.data.totalPage
        }
        this.usersData._loading = false
      } else {
        this.usersData._loading = false
        this.$swal(
          `Oops!`,
          res.message,
          'error'
        )
      }
    },
    async fetchCompanies() {
      let res = await this.getCompanies()
      this.companies = res.data
      this.companies.unshift({
        company: 'All',
        id: '',
        location: ''
      });
    },
    async doRemoveUser(id) {
      this.$swal({
          title: 'Yakin menghapus user ini ?',
          text: `Periksa Kembali Seluruh Data`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Hapus'
        }).then(async (result) => {
          if (result.isConfirmed) {
            this.loading_status = true

            let res = await this.removeUserById({
              user_id: id,
            })

            if (res.status == 'success') {
              this.loading_status = false
              this.$swal('User removed!', 'User Berhasil dihapus', 'success')
              this.fetchUsers()
            } else {
              this.loading_status = false
              if (res.data.message != null)
                this.$swal('Error', res.data.message, 'error')
              else
                this.$swal(
                  'Error',
                  'Something wrong with the server. Please try again later.',
                  'error'
                )
            }
          }
        })
    },
  },
}
</script>
